import { Component, OnInit } from '@angular/core';
import { Menu_Document, Menu } from '../../model/menu';
import { HttpClient } from '@angular/common/http';
import { SelectListItem } from '../../lib/select/select-property';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from '../../../../../Shared-Lib/component/dialog/dialog.service';
import { FilterDataService } from '../../services/filter-data.service';
import { DataService } from '../../../../../Shared-Lib/services/data.service';

@Component({
  selector: 'app-menu-edit',
  templateUrl: './menu-edit.component.html',
  styleUrls: ['./menu-edit.component.css']
})
export class MenuEditComponent implements OnInit {

  Doc: Menu_Document;
  SubmitCheck: boolean = false;
  result: any;
  //NEW or edit
  DocMode: string = 'NEW';
  Title: string = 'Create';
  ControllerName = 'Menu';

  constructor(private route: ActivatedRoute,
    private DlgService: DialogService, private filterService: FilterDataService,
    private router: Router, private dataService: DataService) {
    this.Doc = new Menu_Document(DlgService, router, dataService);
    this.Doc.SelectedEnabled = 1;
    this.Doc.SelectedDisplay = 1;
    this.dataService.getData(this.ControllerName + '/init', null,
      (data) => {
        this.Doc.ddlParent = new Array<SelectListItem>();
        let i = 1;
        data.Menus.forEach(it => {
          let o: SelectListItem = {
            value: it.MenuID,
            text: it.MenuTitle,
            index: i++
          };
          this.Doc.ddlParent.push(o);
        });
        const firstItem: SelectListItem = { value: '0', text: 'Root', index: 0 };
        this.Doc.ddlParent.unshift(firstItem);
      });
  }

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');

    if (id) {
      //edit mode
      this.Doc.GetDocument(id);
      this.DocMode = "EDIT";
      this.Title = "Edit";
    }
    else {
      //create mode
      this.Title = "Create";
      this.Doc.MenuPID = '0';
      this.Doc.MenuIcon = 'fas fa-search';
    }
  }

  isValid(): boolean {
    if (this.Doc.MenuTitle && this.Doc.MenuTitle !== ''
      && this.Doc.MenuLink && this.Doc.MenuLink !== ''
      && this.Doc.MenuIcon && this.Doc.MenuIcon !== '') {
      return false;
    }
    return true;
  }

  Submit() {
    let postData: Menu = {
      MenuID: this.Doc.MenuID,
      MenuPID: this.Doc.MenuPID,
      MenuTitle: this.Doc.MenuTitle,
      MenuLink: this.Doc.MenuLink,
      MenuBreadcrumb: this.Doc.MenuBreadcrumb,
      OrderSeq: this.Doc.OrderSeq,
      IsEnabled: true,
      MenuIcon: this.Doc.MenuIcon,
      IsDisplayed: this.Doc.SelectedDisplay === 1
    };

    //Validation
    this.dataService.addData(this.ControllerName + '/valid', postData,
      //success
      (data) => {
        if (data.Result.Result == "Passed") {
          this.WriteDB(postData);
        }
        else if (data && data.Result.Result == "Warning") {
          this.result = this.DlgService.Warning(data.Result.Message);
          this.result.then((ret) => {
            if (ret === 'Yes')
              this.WriteDB(postData);
          });
        }
        else if (data.Result.Result == "Failed") {
          this.DlgService.ErrorInformation(data.Result.Message);
        }
        else {
          this.DlgService.ErrorInformation("Unexpected Result: " + data.Result.Result);
        }
      });
  }

  Cancel() {
    let lastPageInfo = this.filterService.GetSearchInfo();
    console.log(lastPageInfo);
    if (lastPageInfo.RouteName) {
      this.router.navigate([lastPageInfo.RouteName]);
    }
    else
      this.router.navigate(['/Home/Menu']);
  }

  WriteDB(postData) {
    if (this.DocMode === "NEW") {
      this.dataService.addData(this.ControllerName, postData, (data) => {

        let result = this.DlgService.CreateSubmit();
        result.then((ret) => {
          if (ret === 'Back') {
            this.Cancel();
          }
          else if (ret === 'Create Another') {
            this.Doc.MenuPID = '0';
            this.Doc.MenuTitle = '';
            this.Doc.MenuLink = '';
            this.Doc.MenuBreadcrumb = '';
            this.Doc.OrderSeq = '0';
            this.Doc.SelectedEnabled = 1;
            this.Doc.MenuIcon = 'fas fa-search';
            this.Doc.SelectedDisplay = 1;
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
    else if (this.Doc.MenuPID && this.DocMode === "EDIT") {
      let postData: Menu = {
        MenuID: this.Doc.MenuID,
        MenuPID: this.Doc.MenuPID,
        MenuTitle: this.Doc.MenuTitle,
        MenuLink: this.Doc.MenuLink,
        MenuBreadcrumb: this.Doc.MenuBreadcrumb,
        OrderSeq: this.Doc.OrderSeq,
        IsEnabled: true,
        MenuIcon: this.Doc.MenuIcon,
        IsDisplayed: this.Doc.SelectedDisplay === 1
      };
      this.dataService.updateData(`${this.ControllerName}/${postData.MenuID}`, postData, (data) => {

        let result = this.DlgService.EditSubmit();
        result.then((ret) => {
          if (ret === 'Back') {
            this.Cancel();
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }
}
